const lang = {
  items: "Items",
  add_item: "Add Item",
  add_new_item: "Add New Item",
  edit_item: "Edit Item",
  category_list: "Category List",
  add_category: "Add Category",
  item_list: "Items List",
  warehouse_list: "Warehouses List",
  add_new: "Add New",
  add_warehouse: "Add Warehouse",
  edit_warehouse: "Edit Warehouse",
  add_brand: "Add Brand",
  edit_brand: "Edit Brand",
  brand_list: "Brands List",
};
module.exports = lang;
